import { makeStyles, createStyles, Tooltip, Button, Dialog, DialogContent, DialogActions, IconButton, Theme } from '@material-ui/core';
import { grey } from '@material-ui/core/colors';
import { useContext, useState, useEffect, useRef, useLayoutEffect, useMemo, FC } from 'react';
import { FormContext, useDataValue, useForceRedraw, registry, FormControlProps } from '..';
import { useDispatch } from 'react-redux';
import { catchError } from 'rxjs/operators';
import { empty } from 'rxjs';
import { ArrowBackIos, ArrowForwardIos, CloudDownload, Close, Delete } from '@material-ui/icons';
import { ImageGalleryControlDefinition } from '../services/layout';
import { deleteImage } from '../../../../redux';
import React from 'react';
// @ts-ignore
import Slider from 'react-styled-carousel';
export interface ImageGalleryProps extends FormControlProps<ImageGalleryControlDefinition> {
}

const THUMBNAIL_DIMENSION = 52;
const useStyles = makeStyles(function (theme: Theme) {
  return createStyles({
    imageViewer: { flex: 1 },
    navButton: { position: 'absolute', verticalAlign: 'middle', padding: 0, color: grey[50], top: 0, bottom: 0, borderRadius: 0 },
    prevButton: { left: 0 },
    nextButton: { right: 0 },
    closeButton: { position: 'absolute', top: 0, left: theme.spacing(3), color: grey[50] },
    deleteButton: { position: 'absolute', top: 0, right: 0, color: grey[50] },
    root: { flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'stretch', overflow: 'hidden', position: 'relative', padding: theme.spacing(0, 2), backgroundColor: grey[100] },
    dialogPaper: { flexDirection: 'row', alignItems: 'stretch', backgroundColor: 'black' },
    image: { height: THUMBNAIL_DIMENSION, width: 'calc(100% - 1px)', objectFit: 'contain', backgroundColor: 'black' },
    downloadButton: { height: THUMBNAIL_DIMENSION, width: 'calc(100% - 1px)', backgroundColor: theme.palette.background.paper, borderRadius: 0 },
    selectedImage: { width: '100%', height: '100%', objectFit: 'contain' },
    carouselNavButton: { color: '#000', position: 'absolute', width: '16px', top: 'calc(50% - 11px)', border: 0, cursor: 'pointer', outline: 'none', zIndex: 1 },
  });
});
export const ImageGallery: FC<ImageGalleryProps> = function (props) {
  const { definition } = props;
  const { scope, evalID, imageService } = useContext(FormContext);
  const [ images, setImages ] = useState<any[]>([]);
  const [ selectedImage, setSelectedImage ] = useState<number | null>(null);
  const [ promptDelete, setPromptDelete ] = useState(false);
  const [ downloadError, setDownloadError ] = useState(false);
  const imageIDs = useDataValue<string[]>(definition.dataPath);
  const dispatch = useDispatch();
  const classes = useStyles(props);

  useEffect(
    function e() {
      const obs = imageService!.getImageData(imageIDs || []);
      const sub = obs.subscribe(function (data) {
        return setImages(
          data.filter(function (d) {
            return d !== undefined;
          })
        );
      });
      return function () {
        return sub.unsubscribe();
      };
    },
    [imageIDs]
  );
  const carouselRef = useRef<HTMLDivElement>(null);
  const [width, setWidth] = useState(0);

  useLayoutEffect(() => {
    if (carouselRef.current) {
      setWidth(carouselRef.current!.clientWidth);
    }
  }, [carouselRef.current])

  const imagesToShow = useMemo(
    function () {
      return Math.floor((width * 0.875) / (THUMBNAIL_DIMENSION + 4));
    },
    [width]
  );
  const forceRedraw = useForceRedraw([images, imagesToShow]);
  const onImageClick = function (index: number) {
    return function () {
      onSelectImage(index);
    };
  };
  const onSelectImage = function (index: number | null) {
    if (typeof index === 'number') {

      const i = images[index!];

      if (i && !i.uri) {
        // TODO: use returned observable to fire the store image action
        imageService!.downloadImage(i.id)
          .pipe(
            catchError(function (error) {
              console.log(error);
              setDownloadError(true);
              return empty();
            })
          )
          .subscribe(function (newImageData) {
            const newImages = [...images];
            newImages.splice(index, 1, newImageData);
            setImages(newImages);
          });
      }
    }

    setSelectedImage(index);
  };

  const carousel = useMemo(
    function () {
      // if (width[0] === 0 || forceRedraw) {
      //   return null;
      // }
      if (width === 0 || forceRedraw) {
        return null;
      }
      return (
        <Slider
          cardsToShow = { imagesToShow }
          autoSlide = { false }
          LeftArrow = { <ArrowBackIos className = { classes.carouselNavButton } style = { { left: 0 } }></ArrowBackIos> }
          RightArrow = { <ArrowForwardIos className = { classes.carouselNavButton } style = { { right: 0 } }></ArrowForwardIos> }
          DotsWrapper = { () => null }>
          { images.map((e, t) =>
            e.uri
              ? <img key = { e.id } id = { e.id } src = { e.uri } onClick = { onImageClick(t) } className = { classes.image }></img>
              : <Tooltip title = { 'Download' }>
                  <Button key = { e.id } onClick = { onImageClick(t) }  color = { 'primary' } className = { classes.downloadButton }>
                    <CloudDownload></CloudDownload>
                  </Button>
                </Tooltip>
          )}
        </Slider>
      );
    },
    [forceRedraw, images]
  );
  if (images.length === 0) {
    return null;
  }
  const onConfirmDelete = function () {
    if (typeof evalID === 'string') {
      dispatch(
        deleteImage({
          toRemove: images[selectedImage!].id,
          original: images.map((p) => p.id ),
          evalID: evalID,
          scope: scope,
          path: definition.dataPath,
        })
      );
    }

    onSelectImage(null);
    setPromptDelete(false);
  };

  const onPreviousImageClick = function () {
    onSelectImage(selectedImage! - 1);
  };

  const onNextImageClick = function () {
    onSelectImage(selectedImage! + 1);
  };

  const onFullScreenKeyDown = function (e: React.KeyboardEvent) {
    if ('ArrowLeft' === e.key && selectedImage! > 0) {
      onSelectImage(selectedImage! - 1);
    } else if ('ArrowRight' === e.key && selectedImage! < images.length - 1) {
      onSelectImage(selectedImage! + 1);
    } else if (e.key === 'Escape') {
      onSelectImage(null);
    }
  };
  const downloadErrorMessage = (
    <Dialog aria-labelledby = { 'simple-dialog-title' } open = { downloadError } onKeyDown = { onFullScreenKeyDown }>
      <DialogContent>
        The image could not be retrieved from the server at this time.
      </DialogContent>
      <DialogActions>
        <Button
          aria-label = { 'ok' }
          onClick = { function () {
            setDownloadError(false);
            onSelectImage(null);
          } }>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );

  const imageViewer = (
    <React.Fragment>
      <Dialog
        aria-labelledby = { 'simple-dialog-title' }
        open = { selectedImage !== null }
        onKeyDown = { onFullScreenKeyDown }
        onClose = { () => onSelectImage(null) }
        classes = { { paper: classes.dialogPaper } }>
        <div className = { classes.imageViewer }>
          <Button
            aria-label = { 'back' }
            onClick = { onPreviousImageClick }
            className = { classes.navButton + ' ' + classes.prevButton }
            disabled = { selectedImage === 0 }>
            <ArrowBackIos></ArrowBackIos>
          </Button>
          <Button
            aria-label = { 'next' }
            onClick = { onNextImageClick }
            className = { classes.navButton + ' ' + classes.nextButton }
            disabled = { selectedImage === images.length - 1 }>
            <ArrowForwardIos></ArrowForwardIos>
          </Button>
          <IconButton
              edge = { 'start' }
              aria-label = { 'close' }
              onClick = { () => onSelectImage(null) }
              size = { 'medium' }
              className = { classes.closeButton }>
            <Close></Close>
          </IconButton>
        </div>
        <IconButton
          aria-label = { 'delete' }
          onClick = { () => setPromptDelete(true) }
          size = { 'medium' }
          className = { classes.deleteButton }>
          <Delete></Delete>
        </IconButton>
        { selectedImage !== null &&
          <img
            id = { images[selectedImage].id }
            src = { images[selectedImage].uri }
            className = { classes.selectedImage }>
          </img>
        }
      </Dialog>
      <Dialog aria-labelledby = { 'simple-dialog-title' } open = { promptDelete }>
        <DialogContent>
          Are you sure you want to delete this image?
        </DialogContent>
        <DialogActions>
          <Button
            aria-label = { 'cancel' }
            onClick = { () => setPromptDelete(false) }>
            Cancel
          </Button>
          <Button
            aria-label = { 'delete' }
            onClick = { onConfirmDelete }
            color = { 'primary' }>
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );

  return (
    <div className = { classes.root }>
      <div ref = { carouselRef }>
        { carousel }
      </div>
      { imageViewer }
      { downloadErrorMessage }
    </div>
  )
};
registry.registerComponent('ImageGallery', ImageGallery);
